import { useCallback, useRef, useState } from 'react';
const useConsoleInput = () => {
  const [inputHistory, setInputHistory] = useState([]);
  const [editableCopyOfInputHistory, setEditableCopyOfInputHistory] = useState(['']);
  const [currentEditedHistoryIndex, setCurrentEditedHistoryIndex] = useState(0);
  const currentCommandRef = useRef();
  currentCommandRef.current = editableCopyOfInputHistory[currentEditedHistoryIndex];
  const setCurrentCommand = useCallback(newCommand => {
    const newEditedHistory = [...editableCopyOfInputHistory];
    newEditedHistory[currentEditedHistoryIndex] = newCommand;
    setEditableCopyOfInputHistory(newEditedHistory);
  }, [currentEditedHistoryIndex, editableCopyOfInputHistory]);
  const addCurrentCommandToHistory = useCallback(() => {
    const commandToAdd = currentCommandRef.current;
    if (commandToAdd == null) {
      return;
    }
    const isDuplicateInput = commandToAdd === inputHistory[0];
    const isEmptyInput = commandToAdd.trim().length === 0;
    if (isDuplicateInput || isEmptyInput) {
      setEditableCopyOfInputHistory(['', ...inputHistory]);
      return;
    }
    setInputHistory([commandToAdd, ...inputHistory]);
    setEditableCopyOfInputHistory(['', commandToAdd, ...inputHistory]);
    setCurrentEditedHistoryIndex(0);
  }, [inputHistory]);
  const copyPreviousHistoryItemToCurrentCommand = useCallback(() => {
    const canGoBack = currentEditedHistoryIndex < editableCopyOfInputHistory.length - 1;
    if (!canGoBack) {
      return;
    }
    setCurrentEditedHistoryIndex(currentEditedHistoryIndex + 1);
  }, [currentEditedHistoryIndex, editableCopyOfInputHistory.length]);
  const copyNextHistoryItemToCurrentCommand = useCallback(() => {
    const canGoForward = currentEditedHistoryIndex > 0;
    if (!canGoForward) {
      return;
    }
    setCurrentEditedHistoryIndex(currentEditedHistoryIndex - 1);
  }, [currentEditedHistoryIndex]);
  return {
    addCurrentCommandToHistory,
    copyNextHistoryItemToCurrentCommand,
    copyPreviousHistoryItemToCurrentCommand,
    currentCommandRef,
    numberOfHistoryItems: inputHistory.length,
    setCurrentCommand
  };
};
export default useConsoleInput;